// ============================================================
// PlayerInWindowPlugin — opens the player in a separate browser window
// Registers the PlayerInWindowBtn UI control and handles the
// player-in-window:open event for programmatic triggering.
// ============================================================
import type { IPlugin, PluginContext } from '../../core/types';
import { PlayerInWindowBtn } from './PlayerInWindowBtn';

export class PlayerInWindowPlugin implements IPlugin {
  readonly name = 'player-in-window';

  private ctx: PluginContext | null = null;

  init(ctx: PluginContext): void {
    this.ctx = ctx;
    ctx.uiRegistry.register('player-in-window-button', PlayerInWindowBtn);
    ctx.logger.debug('PlayerInWindowPlugin initialized');
  }

  destroy(): void {
    this.ctx?.uiRegistry.unregister('player-in-window-button', PlayerInWindowBtn);
    this.ctx = null;
  }
}
